import BaseModelInstance from './base.model'
import { RecruitingLeadSource as ModelDefinition } from './model-definitions'

class RecruitingLeadSource extends BaseModelInstance {
  afterSet = (key, value) => {}

  constructor(attribs) {
    super(ModelDefinition, attribs)
  }
}

export default RecruitingLeadSource
